import {
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  makeStyles,
  DialogContent,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
  Paper,
  Collapse,
  TextField,
  Chip,
  Switch,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import CloseIcon from "@material-ui/icons/Close";
// import {
//   fetchRolesAndTypes,
//   fetchViewSponsorDetails,
// } from "../../../../containers/actions/ecosystemActions";
import { useDispatch, useSelector } from "react-redux";
// import {
//   FETCH_ROLES_AND_TYPES,
//   FETCH_VIEW_SPONSOR_DETAILS,
//   FETCH_VIEW_SPONSOR_DETAILS_LOADING,
// } from "../../../../containers/actions/types";
import usePrevious from "../../../common/helperFunctions/usePrevious";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import ReviewEcosystem from "./ReviewEcosystem";
import { FETCH_COLLABORATOR_TYPE_LOADING, FETCH_NETWORK_TYPES_LOADING, FETCH_SELECTED_SPONSOR_DETAILS_LOADING, GET_NETWORK_ROLES_LOADING } from "../../../../containers/actions/types";
import { fetchCollaboratorType, fetchNetworkType, fetchSelectedSponsorDetails, getNetworkRoles } from "../../../../containers/actions/netwrokActions";
import SponsorNetworkList from "./SponsorNetworkList";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import BackDropLoading from "../../../common/helperFunctions/BackDropLoading";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#F5F9FF",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
    table: {
    maxWidth: 650,
    border: "1px solid #e0e0e0",
    marginTop: 10,
  },
  smallCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
    headerCell: {
    padding: "6px 8px",
    fontSize: "0.875rem",
  },
  bodyCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },

    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
    marginBottom: "4px",
    marginTop: "4px",
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
}));

const ViewScreen = (props, data) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, rowData, handleCloseViewScreen } = props;

  const [fetchedData, setFetchedData] = useState({});
  const {
    sponsorDetails = {}, // Provide a default empty object to avoid destructuring undefined
    adminDetails,
    handleSponsorNameChange,
    handleSponsorShortcutNameChange,
    handleCountryChange,
    handleStateChange,
    handleCityChange,
    handlePostCodeChange,
    handleStreetAddress1Change,
    handleStreetAddress2Change,
    userStatusesData,
    handleStatusChange,
    Country,

    handleFullNameChange,
    handleEmailAddressChange,
    handlePhoneChange,
    handleNext,
    existingSponsorFlow,
  } = props;

  const {
    sponsorName,
    sponsorNameShortcut,
    orgCode,
    selectedCountry,
    states,
    selectedState,
    cities,
    selectedCity,
    postCode,
    streetAddress1,
    streetAddress2,
    selectedStatus,
  } = sponsorDetails;
  const [networkTypes, setNetworkTypes] = useState([]);

    const [partnerTypes, setPartnerTypes] = useState([]);
    const [modalities, setModalities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const initialPartnerTypes = useSelector(
      (state) => state?.network?.partnerDetails || []
    );
    // console.log("initialNetworkTypes",initialNetworkTypes)
    // console.log("initialPartnerTypes",initialPartnerTypes)
  
    const initialPartnerTypesLoading = useSelector(
      (state) => state?.network?.partnerDetailsTypeLoading || []
    );
  
    useEffect(() => {
      dispatch({
        type: FETCH_COLLABORATOR_TYPE_LOADING,
        payload: true,
      });
             if (rowData) {
           dispatch(fetchCollaboratorType(rowData?.ecosystemId));
             }
    }, [rowData]);
  
    useEffect(() => {
      if (initialPartnerTypes && initialPartnerTypes?.data) {
        setPartnerTypes(initialPartnerTypes?.data);
      }
    }, [initialPartnerTypes]);
  
    const getRoles = useSelector((state) => state?.network?.getAllRoles || []);
  
    const getRolesLoading = useSelector(
      (state) => state?.network?.getAllRolesLoading
    );
  
    const OPEN_BACKDROP = "OPEN_BACKDROP";
    const DESTROY_BACKDROP = "DESTROY_BACKDROP";
    
  
    const fetchProductModalities = async () => {
      setLoading(true);
      setError(null); // Reset error state before new fetch
  
      // Open backdrop before API call
      // dispatch({
      //   type: OPEN_BACKDROP,
      // });

      if (rowData?.networkURL && fetchedData?.SponsorDetails?.[0]?.network) {
  
      try {
        const url = `${rowData?.networkURL}/Pharma%20Contract%20Manufacturing/${fetchedData?.SponsorDetails?.[0]?.network}/Pharma%20Co/Admin/fetchPlantDrugTypes/false`;
  
        const response = await axios.get(url);
  
        const drugTypeList = response.data?.data?.drugTypeList || [];
  
        const formatted = drugTypeList.map((item, index) => ({
          ...item,
          id: item.drugTypeID || `ID-${index + 1}`,
          name: item.drugTypeName || "",
          selected: !!item.activated,
          isNew: false,
        }));
  
        setModalities(formatted);
      } catch (error) {
        setError("Something went wrong. Please try again.");
      } finally {
        // Always close backdrop and stop loading
        // dispatch({
        //   type: DESTROY_BACKDROP,
        // });
        setLoading(false);
      }
    }
    };
  
    useEffect(() => {
      fetchProductModalities();
    }, [rowData?.networkURL && fetchedData?.SponsorDetails?.[0]?.network]);

    const initialNetworkTypes = useSelector(
      (state) => state?.network?.networkDetails || []
    );
  
    // console.log("networkUrl",networkURL)
    const initialNetworkTypesLoading = useSelector(
      (state) => state?.network?.fetchNetworkTypeLoading || []
    );

    console.log(networkTypes, "networkTypes")

      useEffect(() => {
        if (
          initialNetworkTypes?.NetworkTypes &&
          initialNetworkTypes?.NetworkTypes.length > 0
        ) {
          const types = initialNetworkTypes.NetworkTypes;
          setNetworkTypes(types);
    
          // Find and set the active network type
        }
      }, [initialNetworkTypes]);

    useEffect(() => {
      dispatch({
        type: FETCH_SELECTED_SPONSOR_DETAILS_LOADING,
        payload: true,
      });
      dispatch(
        fetchSelectedSponsorDetails({
          sponsorId: rowData.organizationId,
          ecosystemId: rowData.ecosystemId,
        })
      );

      // dispatch(fetchUserStatus());
    }, []);

    console.log("rowData",rowData)
  
    let fetchViewSponsorLoading = useSelector(
      (state) => state.network.selectedSponsorDetailsLoading
    );
  
    let fetchViewSponsorData = useSelector(
      (state) => state?.network?.selectedSponsorDetails || []
    );
  const handleClose = () => {
    // dispatch({
    //   type: FETCH_VIEW_SPONSOR_DETAILS,
    //   payload: {},
    // });
    // dispatch({
    //   type: FETCH_ROLES_AND_TYPES,
    //   payload: [],
    // });
    handleCloseViewScreen();
  };



  let errors = useSelector((state) =>
    state.ecosystems.fetchViewSponsorData
      ? state.ecosystems.fetchViewSponsorData
      : {
          status: "false",
          errror: "Something went wrong. Please contact Schrocken Support.",
        }
  );

  let prevFetchViewSponsorData = usePrevious(fetchViewSponsorData);

  useEffect(() => {
    if (
      JSON.stringify(fetchViewSponsorData) !==
      JSON.stringify(prevFetchViewSponsorData) &&    fetchViewSponsorData?.SponsorDetails
    ) {
      setFetchedData(fetchViewSponsorData);
        
    }
  }, [fetchViewSponsorData, prevFetchViewSponsorData]);


  useEffect(() => {
  if (fetchedData?.SponsorDetails?.[0]) {
    dispatch({
      type: GET_NETWORK_ROLES_LOADING,
      payload: true,
    });

    dispatch(
      getNetworkRoles({
        ecosystemId: rowData?.ecosystemId,
        network: fetchedData?.SponsorDetails?.[0]?.network,
        ecosystemUrl:rowData?.networkURL
      })
    );
  }
}, [fetchedData]);

  let rolesAndTypesData = useSelector((state) =>
    state.ecosystems.rolesAndTypes?.data
      ? state.ecosystems.rolesAndTypes.data
      : []
  );


    useEffect(() => {
      dispatch({
        type: FETCH_NETWORK_TYPES_LOADING,
        payload: true,
      });
  
      if (rowData) {
        dispatch(fetchNetworkType(rowData.ecosystemId));
      }
    }, [rowData]);
  // let prevRolesAndTypes = usePrevious(rolesAndTypes);

  const [openRows, setOpenRows] = useState({});

  const handleRowClick = (id) => {
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [id]: !prevOpenRows[id],
    }));
  };
console.log("fetchedData",fetchedData)
console.log("fetchViewSponsorData",fetchViewSponsorData)
  return (
   
    <Dialog open={openDialog} fullScreen>
      <DialogTitle style={{ padding: "0px" }}>
        <Grid item xs={12} className={classes.header}>
          <Grid item xs={12} className={classes.titleGrid}>
            <Grid item xs={12} className={classes.head}>
              <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                View Sponsor Network
              </Typography>
              <Typography>
                Please view the sponsor network details in the fields below
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={2} sm={2} md={2}>
            <Typography
              variant="body2"
              className={classes.closeBtn}
              onClick={handleClose}
            >
              Cancel{" "}
              <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <BackDropLoading />
      {fetchViewSponsorLoading === true ? (
        <DialogContent>
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress thickness="7" />
          </div>
        </DialogContent>
      ) : errors.status === false ? (
        <Grid
          style={{
            paddingLeft: "150px",
            paddingRight: "150px",
            paddingTop: "30px",
          }}
        >
          <Typography
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            {errors.error}
          </Typography>
        </Grid>
      ) : (
        <DialogContent
          style={{
            paddingLeft: "160px",
            paddingTop: "32px",
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body2" className={classes.inline}>
                Sponsor Details
              </Typography>
              <hr className={classes.hrLine} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Sponsor Name
              </Typography>
              <Typography className={classes.textfieldWidth}>
   {fetchedData?.SponsorDetails?.[0]?.sponsorName}
              </Typography>
            </Grid>
                        <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Sponsor Short Name
              </Typography>
              <Typography className={classes.textfieldWidth}>

                {fetchedData?.SponsorDetails?.[0]?.sponsorShortFormName || "NA"}
              </Typography>
            </Grid>

                        <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Street Address 1
              </Typography>
              <Typography className={classes.textfieldWidth}>
                   {fetchedData?.SponsorDetails?.[0]?.streetAddress1 || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Street Address 2
              </Typography>
              <Typography className={classes.textfieldWidth}>
                  {fetchedData?.SponsorDetails?.[0]?.streetAddress2 || "NA"}
              </Typography>
            </Grid>

                        <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Country
              </Typography>
              <Typography className={classes.textfieldWidth}>
            {/* {Country.getAllCountries().find(
            (country) => country.isoCode === sponsorDetails.selectedCountry
          )?.name ?? "Country not found."} */}
               {fetchedData?.SponsorDetails?.[0]?.country || "NA"}
              </Typography>
            </Grid>


            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                State
              </Typography>
              <Typography className={classes.textfieldWidth}>
            {/* {State.getStatesOfCountry(sponsorDetails.selectedCountry).find(
            (state) => state.isoCode === sponsorDetails.selectedState
          )?.name ?? "State not found."} */}
              {fetchedData?.SponsorDetails?.[0]?.state || "NA"}
              </Typography>
            </Grid>

                       <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                City
              </Typography>
              <Typography className={classes.textfieldWidth}>
            {/* {sponsorDetails.selectedCity} */}
               {fetchedData?.SponsorDetails?.[0]?.city || "NA"}
              </Typography>
            </Grid>
 
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Post Code
              </Typography>
              <Typography className={classes.textfieldWidth}>
   {fetchedData?.SponsorDetails?.[0]?.postCode || "NA"}
              </Typography>
            </Grid>

<Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Status
              </Typography>
              <Typography className={classes.textfieldWidth}>
   {fetchedData?.SponsorDetails?.[0]?.status || "NA"}
              </Typography>
            </Grid>

                        <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Organization Code
              </Typography>
              <Typography className={classes.textfieldWidth}>
                  {fetchedData?.SponsorDetails?.[0]?.organizationCode || "NA"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={11}>
              <hr className={classes.hr} />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body2" className={classes.inline}>
                Admin Details
              </Typography>
              <hr className={classes.hrLine} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Full Name
              </Typography>
              <Typography className={classes.textfieldWidth}>
                   {fetchedData?.SponsorDetails?.[0]?.fullName || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Email Address
              </Typography>
              <Typography className={classes.textfieldWidth}>
                  {fetchedData?.SponsorDetails?.[0]?.emailAddress || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                variant="body1"
                style={{ fontWeight: "bold", marginBottom: "8px" }}
              >
                Phone
              </Typography>

              <Typography className={classes.textfieldWidth}>
                 {fetchedData?.SponsorDetails?.[0]?.phoneNumber || "NA"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={11}>
              <hr className={classes.hr} />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body2" className={classes.inline}>
                Network Details
              </Typography>
              <hr className={classes.hrLine} />
            </Grid>

                      <Table style={{ marginTop: "2rem" }} className={classes.table}>
            <TableHead style={{ backgroundColor: "#F9F9FC" }}>
              <TableRow>
                <TableCell className={classes.smallCell}>Selection</TableCell>
                <TableCell className={classes.smallCell}>
                  Network Type
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  Network Type ID
                </TableCell>
                 </TableRow>
            </TableHead>
            {initialNetworkTypesLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : networkTypes.length > 0 ? (
              <TableBody>
                {networkTypes.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className={classes.smallCell}>
                      {/* <input
                      type="radio"
                      style={{ width: '1rem', height: '1rem' }}
                       checked={selectedIndices.includes(index)}
                      onChange={() => handleCheckboxChange(index)}
                    /> */}
                      <input
                        type="radio"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          accentColor: "#EC6535",
                        }}
                        //  checked={selectedIndices === index}
                        checked={item.activated === true}
                        // onChange={() => handleCheckboxChange(index)}
                        disabled={item.isNew}
                      />
                    </TableCell>
                    <TableCell className={classes.smallCell}>
   
                        <Typography variant="body2">
                          {item.networkType}
                        </Typography>
                   
                    </TableCell>
                    <TableCell align="right" className={classes.smallCell}>
                      {/* {item.networkTypeID} */}
                      {/* {item.display_id < 10 ? `0${item.display_id}` : item.display_id}
                       */}

                      {item.display_id !== null && item.display_id !== undefined
                        ? item.display_id < 10
                          ? `0${item.display_id}`
                          : item.display_id
                        : item.ecosystem_type_id < 10
                        ? `0${item.ecosystem_type_id}`
                        : item.ecosystem_type_id}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : initialNetworkTypes?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  {"Something went wrong. Please contact Schrocken Support."}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </Table>

                <Grid item xs={12} style={{ marginTop: "1.5rem" }}>
                  <Typography style={{ fontWeight: "bold" }}>Network URL</Typography>
                  <Typography>{fetchedData?.SponsorDetails?.[0]?.networkURL}</Typography>
                </Grid>
      <Table style={{ marginTop: "2rem" }} className={classes.table}>
        <TableHead style={{ backgroundColor: "#F9F9FC" }}>
          <TableRow>
            <TableCell className={classes.smallCell}>Selection</TableCell>
            <TableCell className={classes.smallCell}>Partner Types</TableCell>
            <TableCell align="right" className={classes.smallCell}>
              Partner Type ID
            </TableCell>
          </TableRow>
        </TableHead>
        {initialPartnerTypesLoading === true ? (
          <TableRow style={{ height: 150 }}>
            <TableCell colSpan={12}>
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" thickness={7} />
              </div>
            </TableCell>
          </TableRow>
        ) : partnerTypes?.length > 0 ? (
          <TableBody>
            {partnerTypes.map((item, index) => (
              <TableRow key={index}>
                <TableCell className={classes.smallCell}>
                  {/* <Switch
                                              classes={{ root: classes.root }}
                                              checked={selectedIndices.includes(index) || item.activated === true}
                                              onChange={() => handleCheckboxChange(index)}
                                              disabled={item.isNew} 
                                            />                 */}

                  <Switch
                    classes={{ root: classes.root }}
                    checked={item.activated}
                    // onChange={() => handleCheckboxChange(index)}
                    // disabled={item.isNew}
                  />
                </TableCell>
                <TableCell className={classes.smallCell}>
                  <Typography variant="body2">
                    {item.collaborator_type_name}
                  </Typography>
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  {item?.collaborator_type_id || "NA"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : initialPartnerTypes?.status === false ? (
          <TableRow
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            <TableCell colSpan={10} align="center">
              {"Something went wrong. Please contact Schrocken Support."}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
      </Table>

       </Grid>

      <div style={{marginTop:"2rem"}}>
                        <div style={{ display: 'flex', gap: '4rem',flexDirection:"row",lineHeight:"2rem"}}>
                     
                <div>
                <table border="1" style={{borderCollapse:"collapse"}} cellPadding={6} >
                        <thead style={{backgroundColor:"#F9F9FC",lineHeight:"1.5rem"}}>
                          <tr style={{border:"1px solid black"}}>
                            <th style={{border:"none"}} align='left'>Sponsor Role</th>
                            <th style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>Sponsor<br/> Role ID</th>
                          </tr>
                        </thead>
                {getRolesLoading === true ?(
                                              <tr style={{ height: 150 }}>
                                              <td colSpan={12}>
                                                <div style={{ textAlign: "center" }}>
                                                  <CircularProgress color="primary" thickness={7} />
                                                </div>
                                              </td>
                                            </tr>
                            ) : getRoles?.data?.sponsorRoles.length > 0 ? (
                              <tbody>
                              {getRoles?.data?.sponsorRoles.map((role, index) => (
                                <tr style={{border:"1px solid black"}} key={index}>
                                  <td style={{border:"none"}} align='left'>{role.role_name}</td>
                                  <td style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>{role.collaborator_role_id}</td>
                                </tr>
                              ))}
                            </tbody>
                            ) : getRoles?.status === false ? (
                              <tr
                              style={{
                                border: "2px solid rgb(255,0,0)",
                                backgroundColor: "rgb(255,240,240)",
                                Opacity: 1,
                                textAlign: "center",
                                padding: "0.8rem",
                                fontSize: "0.875rem",
                              }}>
                                <td align='center'>
                                {"Something went wrong. Please contact Schrocken Support."}
                                </td>
                              </tr>
                            ) : (
                                 <tr>
                                            <td colSpan={9} align="center">
                                              No records found
                                            </td>
                                          </tr>
                            ) }
                
                
                      </table>
                </div>
                
                    
                <div>
                <table border="1" style={{borderCollapse:"collapse"}} cellPadding={6}>
                        <thead style={{backgroundColor:"#F9F9FC",lineHeight:"1.5rem"}}>
                          <tr style={{border:"1px solid black"}} >
                            <th style={{border:"none"}} align='left'>CMO Role</th>
                            <th style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>CMO <br/> Role ID</th>
                          </tr>
                        </thead>
                        {getRolesLoading === true ?(
                                              <tr style={{ height: 150 }}>
                                              <td colSpan={12}>
                                                <div style={{ textAlign: "center" }}>
                                                  <CircularProgress color="primary" thickness={7} />
                                                </div>
                                              </td>
                                            </tr>
                            ) : getRoles?.data?.cmoRoles?.length > 0 ? (
                              <tbody>
                              {getRoles?.data?.cmoRoles.map((role,index) => (
                                <tr style={{border:"1px solid black"}} key={index}>
                                  <td style={{border:"none"}} align='left'>{role.role_name}</td>
                                  <td style={{border:"none",paddingLeft:"3rem",paddingRight:"1rem"}} align='right'>{role.collaborator_role_id}</td>
                                </tr>
                              ))}
                            </tbody>
                            ) : getRoles?.status === false ? (
                              <tr
                              style={{
                                border: "2px solid rgb(255,0,0)",
                                backgroundColor: "rgb(255,240,240)",
                                Opacity: 1,
                                textAlign: "center",
                                padding: "0.8rem",
                                fontSize: "0.875rem",
                              }}>
                                <td align='center'>
                                {"Something went wrong. Please contact Schrocken Support."}
                                </td>
                              </tr>
                            ) : (
                                 <tr>
                                            <td colSpan={9} align="center">
                                              No records found
                                            </td>
                                          </tr>
                            ) }
                      </table>
                </div>
                
                
                    </div>
                
                                          </div>


          <Grid container spacing={3}>
            <Grid item xs={11}>
              <hr className={classes.hr} />
            </Grid>
          </Grid>
      <Grid item xs={12} style={{ marginTop: "2rem" }}>
        <Typography variant="body2" className={classes.inline}>
          Sponsor Network Configurations
        </Typography>
        <hr className={classes.hrLine} />
      </Grid>

      <Table style={{ marginTop: "2rem" }} className={classes.table}>
        <TableHead style={{ backgroundColor: "#F9F9FC" }}>
          <TableRow>
            <TableCell className={classes.smallCell}>Selection</TableCell>
            <TableCell className={classes.smallCell}>Product Modality</TableCell>
            <TableCell align="right" className={classes.smallCell}>
              Product Modality ID
            </TableCell>
          </TableRow>
        </TableHead>
        {modalities.length > 0 ? (
          <TableBody>
            {modalities.map((modality, index) => (
              <TableRow key={index}>
                <TableCell className={classes.smallCell}>
                  <Switch
                    checked={modality.selected}
                    disabled={true}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.smallCell}>
                  <Typography variant="body2">
                    {modality.name}
                  </Typography>
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  {modality.id}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
      </Table>

      <SponsorNetworkList reviewData={fetchViewSponsorData} />


         



          {/* <Grid container spacing={3}>
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ChevronLeft />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
            backgroundColor: "#707070",
            color: "#FFFFFF",
          }}
          onClick={handleBack}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
            marginRight: "7rem",
          }}
          onClick={handleSendInvitation}
        >
          Send Invitation
        </Button>
      </Grid>
    </Grid> */}
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewScreen;
